import { CrearOrdenPaypal_Parametros, builtArticulo, builtComprarUnidade, builtComprarUnidadeMonto, builtContextoAplicacion, builtCrearOrdenPaypalEntrada, builtDatosSKY, builtDesglose, builtEBMHeaderRequest, builtMonto, builtOrden } from "../Commons/Services/Paypal";
import { ConsultaWS } from "../Commons/ServiciosBase";

export async function creaOrdenPagoPaypal(codigoMoneda:string , cantidad:string, referenciaId:string,  customId:string ,urlExito:string, urlCancel:string ) {

    const datosSky = builtDatosSKY(sessionStorage.getItem("cuenta")!);
    const monto = builtMonto(codigoMoneda,cantidad);
    const articulo = builtArticulo("Pago de servicio SKY","1","Pago de servicio SKY",monto);
    const desglose = builtDesglose(monto);
    const comprarUnidadeMonto = builtComprarUnidadeMonto(monto, desglose);
    const comprarUnidades = builtComprarUnidade(referenciaId,customId,[articulo], comprarUnidadeMonto);
    const urlsAplicacion = builtContextoAplicacion(urlExito,urlCancel);
    const orden = builtOrden(datosSky, "CAPTURE", [comprarUnidades], urlsAplicacion);  
    const cabecera = builtEBMHeaderRequest("CrearOrden","APPS");
    const crearOrdenPaypalEntrada = builtCrearOrdenPaypalEntrada(orden, cabecera);
    const crearOrdenPaypalParametros = CrearOrdenPaypal_Parametros(crearOrdenPaypalEntrada);
    const crearOrdenPaypalRespuesta =  await ConsultaWS(crearOrdenPaypalParametros);

    return crearOrdenPaypalRespuesta;
}

//pendiente funcion para codigo de monedas